import { A } from '@solidjs/router';
import type { JSX } from 'solid-js';
import { EmptyState } from '../components/states';
import { buttonClass } from '../ui/Button';

export function NotFound(): JSX.Element {
  return (
    <main class="page page--narrow">
      <EmptyState
        title="Page not found"
        text="That page does not exist."
        action={
          <A href="/boxes" class={buttonClass('primary', 'md')}>
            Back to boxes
          </A>
        }
      />
    </main>
  );
}
